export const STATUS_COLORS = {
  moving: "#34C759",   // green — running
  idle: "#FF9500",     // orange — idle
  stopped: "#FF3B30",  // red — ignition off
  inactive: "#5AC8FA", // blue — delayed / parked
  offline: "#8E8E93",  // grey — no data
  panic: "#FF3B30",    // red — emergency
};

export const STATUS_LABELS = {
  moving: "Running", idle: "Idle", stopped: "Stopped",
  inactive: "Inactive", offline: "No Data", panic: "Emergency",
};

export function StatusBadge({ status }) {
  const color = STATUS_COLORS[status] || "#8E8E93";
  return (
    <span data-testid={`status-badge-${status}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold" style={{ color }}>
      <span className="status-dot" style={{ background: color }} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}
